window.addEventListener(
'load',
function load()
{
    window.removeEventListener('load', load, false);
    setTimeout(function() {
      document.body.classList.remove('preload_window');
    }, 200);
},
false);

$('span.icon_wraper').hover(function(){
    $(this).next().fadeToggle();
});

$(".logo_slide").slick({
    speed: 3e3,
    autoplay: !0,
    autoplaySpeed: 0,
    centerMode: !0,
    cssEase: "linear",
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: !0,
    infinite: !0,
    pauseOnHover: !0,
    cssEase: "linear",
    initialSlide: 1,
    arrows: false,
    dots: false,
    responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 5, slidesToScroll: 1, infinite: !0, dots: false } },
        { breakpoint: 600, settings: { slidesToShow: 5, slidesToScroll: 3 } },
        { breakpoint: 480, settings: { slidesToShow: 5, slidesToScroll: 3 } },
    ],
})


$(document).ready(function(){
  $('.title_tab ').on('click', function() {
if($(this).hasClass('active')) {
$(this).siblings('.inner_content').slideUp();
$(this).removeClass('active');
}
else {
$('.inner_content').slideUp();
$('.title_tab ').removeClass('active');
$(this).siblings('.inner_content').slideToggle();
$(this).toggleClass('active');
}
});
});

$('.hero_banner_slider_block').slick({
  dots: true,
  arrows: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
  autoplay: false,
  autoplaySpeed: 2500
});


// $('.hero_banner_slider_block').on('afterChange', function(event, slick, currentSlide) {
//   $('.slick-slider-dots li').removeClass('slick-active');
//   $('.slick-slider-dots li button').css('background','#1A181826 !important');
//   $('.slick-slider-dots li').eq(currentSlide).addClass('slick-active');
  

//   setTimeout(() => {
//       $('.slick-slider-dots li.slick-active').css('background','#00000');
//   }, 500);
  
// });



$('.partnered_slider_block').slick({
  autoplay: true,
  infinite: true,
  autoplaySpeed: 0,
  speed: 9000,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: false,
  swipe: false,
  cssEase: 'linear',
  variableWidth: false,
  pauseOnFocus: false,
  pauseOnHover: false,
  responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        { breakpoint: 480, settings: { slidesToShow: 1.5, slidesToScroll: 1 } },
  ],
});


$('.section_slider').slick({
  autoplay: true,
  infinite: true,
  autoplaySpeed: 0,
  speed: 9000,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: false,
  swipe: false,
  cssEase: 'linear',
  variableWidth: false,
  pauseOnFocus: false,
  pauseOnHover: false,
  responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        { breakpoint: 480, settings: { slidesToShow: 1.5, slidesToScroll: 1 } },
  ],
});


if ($(window).width() <= 991){
  $('.product__media-list').slick({
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
      responsive: [
    {
      breakpoint: 751,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        dots: true
      }
    }
  ]
  });
}





$(function () {
$(this).find("variant-selects .swatch-input__label").slice(0, 5).show();

    $( ".collection_list_sec .collection > ul > li" ).each(function( i ) {
      
      $(this).find("variant-selects .swatch-input__label").slice(0, 5).show();
      if ($(this).find("variant-selects .swatch-input__label").length <= 5) {
          $(this).find(".variants_load-more").hide();
      }
    });
    $("body").on('click touchstart', '.variants_load-more', function (e) {
        e.preventDefault();
        $(this).parent().find("variant-selects .swatch-input__label:hidden").show();
        $(this).css('display', 'none');
    });


    $(".collection_list_sec .collection > ul > li").slice(0, 10).show();
    if ($(".collection_list_sec .collection > ul > li").length <= 10) {
        $(".collection_load_more").hide();
    }
    var index = $(".collection_list_sec .collection > ul > li:not(:hidden)").length;;
    $('.count_pro').text(index);
    $("body").on('click touchstart', '.collection_load_more a', function (e) {
        e.preventDefault();
        $(".collection_list_sec .collection > ul > li:hidden").slice(0, 10).slideDown();
        if ($(".collection_list_sec .collection > ul > li:hidden").length == 0) {
            $(".collection_load_more a").css('display', 'none');
        }      
        var totindex1 =$(".collection_list_sec .collection > ul > li:not(:hidden)").length;
        $('.count_pro').text(totindex1);
        // $('html,body').animate({
        //     scrollTop: $(this).offset().top
        // }, 1000);
    });
  
});


$('body .collection_facets_filter .sorting_filter .mobile-facets__summary').click( function(event) {
    event.preventDefault();
    $(this).parent().toggleClass('filter_opeing');
    $(this).next().slideToggle();
});


// $('body .collection_facets_filter .mobile-facets__details .mobile-facets__summary ').click(function(event) {
//   event.preventDefault();
//   console.log("Clicked");

//   let parentDetails = $(this).parents('.mobile-facets__details');
//   $('body .collection_facets_filter .mobile-facets__details .mobile-facets__submenu').hide();

//   setTimeout(() => {
//     console.log("inner Clicked", event);
//     parentDetails.removeClass('menu-opening');
//     parentDetails.removeAttr('open');
//   }, 100);

//   // Slide toggle the next element (which should be the filter options)
//   $(this).next().slideToggle();
//   $(this).next().toggleClass("open");
// });



// $('.all_btn_st').on('mouseenter', function(e) {
//     var parentOffset = $(this).offset(),
//     relX = e.pageX - parentOffset.left,
//     relY = e.pageY - parentOffset.top;
//     $(this).find('span').css({top:relY, left:relX})
// }).on('mouseout', function(e) {
//     var parentOffset = $(this).offset(),
//     relX = e.pageX - parentOffset.left,
//     relY = e.pageY - parentOffset.top;
//     $(this).find('span').css({top:relY, left:relX})
// });





// 21-01-2025 about us page  ====================

window.addEventListener('load', function () {
 
  const images = document.querySelectorAll('.image-gallery .image-item');

 
  images.forEach((image) => {
    image.style.display = 'block'; // Make images visible
    image.style.opacity = '1'; // Optional: Smooth transition
  });
});

// $(document).ready(function(){
// setTimeout(function () {
//   $('.related_products_product').slick({
//     dots: false,
//     infinite: false,
//     arrows: true,
//     speed: 300,
//     prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none"><rect width="48" height="48" rx="24" transform="matrix(-1 0 0 1 48 0)" fill="white"/><path d="M26.3438 18L20.6869 23.6569L26.3438 29.3137" stroke="#1A1818"/></svg></button>',
//     nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none"><rect width="48" height="48" rx="24" fill="white"/><path d="M21.6562 18L27.3131 23.6569L21.6562 29.3137" stroke="#1A1818"/></svg></button>',
//     slidesToShow: 5.2,
//     slidesToScroll: 1,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 1,
//           infinite: true,
//         }
//       },
//       {
//         breakpoint: 575,
//         settings: {
//           slidesToShow: 2.2,
//           slidesToScroll: 1
//         }
//       },
//       {
//         breakpoint: 425,
//         settings: {
//           slidesToShow: 2.2,
//           slidesToScroll: 1
//         }
//       }
//     ]
//   });
//   }, 2500);
// });


$(window).on('load', function(){
  $(".cart__footer-wrapper,.cart_itme").wrapAll( "<div class='cart_page_wrap_sec'><div class='container'><div class='cart_page_inner' /></div></div>");
  if($(".cart_itme cart-items").hasClass("is-empty")) {
    $("body").addClass("cart-is-empty");
  } else {
    $("body").removeClass("cart-is-empty");
  }
});

document.addEventListener("DOMContentLoaded", function () {
    let zakekeButton = document.querySelector(".zakeke-product-button");

    if (zakekeButton) {
        let sizeFieldset = document.querySelector(".option--Size");
        let product_form = document.querySelector(".product__info-container .product-form, .product__info-container .product__description, .product__info-container .icon-with-text");

        if (sizeFieldset) {
            sizeFieldset.style.display = "none";
        }

        if (product_form) {
            product_form.style.display = "none";
        }
    }

    // Observer to detect DOM changes and apply display: none dynamically
    let observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            let sizeFieldset = document.querySelector(".option--Size");
            let product_form = document.querySelector(".product__info-container .product-form, .product__info-container .product__description, .product__info-container .icon-with-text");

            if (zakekeButton) {
                if (sizeFieldset) {
                    sizeFieldset.style.display = "none";
                }
                if (product_form) {
                    product_form.style.display = "none";
                }
            }
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
});





// document.addEventListener('DOMContentLoaded', function () {
//   function getSelectedOptions() {
//     const selectedRadios = document.querySelectorAll('.product-form__input input[type="radio"]:checked');
//     return Array.from(selectedRadios).map(input => input.value.trim()).join(' / ');
//   }

//   function updateVariantByOptions() {
//     const combo = getSelectedOptions();
//     const variantEl = document.querySelector(`.variant-data[data-options="${combo}"]`);

//     if (variantEl) {
//       const variantId = variantEl.dataset.variantId;
//       const imageUrl = variantEl.dataset.variantImage;

//       // Update main product image
//       const imageTarget = document.querySelector(
//         '.product__media-list .slick-slide:first-of-type .product__media-item.grid__item .product__media img'
//       );
//       if (imageTarget && imageUrl) {
//         imageTarget.src = imageUrl;
//       }

//       // Update URL with new variant
//       const newUrl = new URL(window.location.href);
//       newUrl.searchParams.set('variant', variantId);
//       window.history.replaceState({}, '', newUrl);
//     }
//   }

//   // ✅ Run on load in case ?variant exists
//   const params = new URLSearchParams(window.location.search);
//   const initialVariantId = params.get('variant');
//   if (initialVariantId) {
//     const variantEl = document.querySelector(`.variant-data[data-variant-id="${initialVariantId}"]`);
//     if (variantEl) {
//       const imageUrl = variantEl.dataset.variantImage;
//       const imageTarget = document.querySelector(
//         '.product__media-list .slick-slide:first-of-type .product__media-item.grid__item .product__media img'
//       );
//       if (imageTarget && imageUrl) {
//         imageTarget.src = imageUrl;
//       }
//     }
//   }

//   // ✅ Detect swatch change
//   document.body.addEventListener('click', function (e) {
//     const label = e.target.closest('.product-form__input input[type="radio"] + label.swatch-input__label');
//     if (label) {
//       // Delay to ensure input is checked before we query
//       setTimeout(updateVariantByOptions, 10);
//     }
//   });

//   // ✅ Move existing Swiper to the first slide
//   const sliderComponent = document.querySelector('product__media-list');
//   if (sliderComponent && sliderComponent.slick) {
//     sliderComponent.slick("slickGoTo", 0);; // Slide back to first
//     console.log('Slick moved to first slide');
//   } else {
//     console.log('Slick not found or not ready');
//   }
  
// });


// document.addEventListener('DOMContentLoaded', function () {
//   if (window.innerWidth <= 768) {
//     document.body.addEventListener('click', function (e) {
//       const label = e.target.closest('.product-form__input input[type="radio"] + label.swatch-input__label');

//       if (label) {
//         const styleAttr = label.getAttribute('style');
//         const urlMatch = styleAttr && styleAttr.match(/url\(['"]?(.*?)['"]?\)/);

//         if (urlMatch && urlMatch[1]) {
//           let imageUrl = 'https:' + urlMatch[1];
//           imageUrl = imageUrl.replace(/&width=\d+/, '');

//           const targetImg = document.querySelector(
//             '.slider-mobile-gutter .slick-slide:first-of-type .product__media-item.grid__item .product__media img'
//           );

//           if (targetImg) {
//             targetImg.src = imageUrl;
//             targetImg.srcset = '';
//           }
//         }

//         // ✅ Move existing Swiper to the first slide
//         const sliderComponent = document.querySelector('slider-mobile-gutter');
//         if (sliderComponent && sliderComponent.slick) {
//           sliderComponent.slick("slickGoTo", 0);; // Slide back to first
//           console.log('Slick moved to first slide');
//         } else {
//           console.log('Slick not found or not ready');
//         }
        
//       }
//     });
//   }
// });


document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth <= 768) {
    document.body.addEventListener('click', function (e) {
      const label = e.target.closest('.product-form__input input[type="radio"] + label.variant-label');

      if (label) {
        // ✅ Move existing Slick to the first slide
        const sliderComponent = document.querySelector('.product__media-list');
        if (sliderComponent && sliderComponent.slick) {
          $(sliderComponent).slick("slickGoTo", 0);
          console.log('Slick moved to first slide');
        } else {
          console.log('Slick not found or not ready');
        }

        // ⏳ Wait 1 second, then extract variant ID and match with variant data
        setTimeout(() => {
          const url = new URL(window.location.href);
          const variantId = url.searchParams.get('variant');

          if (variantId) {
            const variantData = document.querySelector(`.variant-data[data-variant-id="${variantId}"]`);

            if (variantData) {
              const variantImage = variantData.getAttribute('data-variant-image');
              console.log('Matched Variant Image URL:', variantImage);
              console.log('Matched Variant Image ID:', variantId);
              const targetImg = document.querySelector(
                '.product__media-list .slick-slide:first-of-type .product__media-item.grid__item .product__media img'
              );
              if (targetImg) {
                targetImg.src = variantImage;
                targetImg.srcset = '';
              }
            } else {
              console.log('No matching variant-data found for ID:', variantId);
            }
          } else {
            console.log('Variant ID not found in URL');
          }
        }, 800);
      }
    });
  }
});
